import { render, staticRenderFns } from "./InfoIcons.vue?vue&type=template&id=3f8a218e&scoped=true&"
import script from "./InfoIcons.vue?vue&type=script&lang=js&"
export * from "./InfoIcons.vue?vue&type=script&lang=js&"
import style0 from "./InfoIcons.vue?vue&type=style&index=0&id=3f8a218e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8a218e",
  null
  
)

export default component.exports